// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2203":"07a6b5aa","6179":"07a6b5aa"}[chunkId] + ".chunk.css";
};